<template>
  <div
    class="flex mb-12 cursor-pointer items-center"
    @click="$emit('setProductClick', product)"
  >
    <div class="mr-16 rounded-regular w-56" :style="`background: #EAE9E8`">
      <img
        :src="product.standardImage"
        alt="Produktbild"
        class="object-cover h-full w-full"
      >
    </div>
    <div class="">
      <span class="block">{{ product.title }}</span>
      <span class="text-sm">{{ product.sku }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import  { defineComponent, type PropType } from 'vue';
import { type EcomProduct } from '~/constants/types/product';
import Product from '~/models/product';

export default defineComponent({
  props: {
    item: {
      type: Object as PropType<EcomProduct>,
      required: true,
    },
  },
  computed: {
    product(): Product {
      return new Product({ ecomData: this.item, contentData: null });
    },
    productVariants(): Product[] {
      const variants = this.product.variants;
      return variants
        .reverse()
        .filter((p) => p.category === this.product.category);
    },
  },
});
</script>
